<template lang="pug"></template>
<script>
export default {
	name: 'HomeView'
};
</script>
